<app-abandoned-reservation-header
  [user]="user"
  [translationType]="'AIR_PACKAGE'">
</app-abandoned-reservation-header>
<app-abandoned-reservation-body [hasImage]="true">
  <app-image
    image
    [type]="typeImageHotel"
    [src]="hotelReservationItem?.Hotel?.Thumbnail"
    [maxHeight]="155"
    [borderRadius]="8"
    [borderRadiusOnlyTop]="true">
  </app-image>
  <ng-container content>
    <div class="abandonedPackageReservation">
      <div class="abandonedPackageReservation__air">
        <div class="abandonedPackageReservation__air--header">
          <strong>{{'ADANDONED_RESERVATION_MODULE.FLIGHTS.YOUR_TRIP' | transloco}}</strong>
          <ng-container *ngFor="let sector of sectors; let first = first; let last = last">
            <span class="date">
              <ng-container *ngIf="first">
                {{sector.Flights[0].DepartureDate | date: 'EE, d MMM' | dateFormat | capitalize}} -
              </ng-container>
              <ng-container *ngIf="last">
                {{sector.Flights[0].DepartureDate | date: 'EE, d MMM' | dateFormat | capitalize}}
              </ng-container>
            </span>
          </ng-container>
        </div>
        <div class="abandonedPackageReservation__air--body">
          <ng-container *ngFor="let sector of sectors">
            <app-simple-travel-summary
              [options]="[sector]"
              [summaryProvider]="summaryProvider"
              [type]="sector.SectorNumber">
            </app-simple-travel-summary>
          </ng-container>
        </div>
      </div>
      <div class="abandonedPackageReservation__hotel">
        <app-hotel-segment-detail
          [hotelReservation]="hotelReservationItem"
          [isAdandonedPackageReservation]="true"
          [showRoomsDetail]="true">
        </app-hotel-segment-detail>
      </div>
    </div>
    <app-abandoned-reservation-actions
      [itineraryId]="itinerary?.Id"
      [reservationType]="reservationType"
      [userId]="user?.id"
      [isMobile]="isMobile"
      [isLoadingCancellation]="isLoadingCancellation"
      (cancelEvent)="cancelEvent.emit(airReservationItem?.Id)">
    </app-abandoned-reservation-actions>
  </ng-container>
</app-abandoned-reservation-body>